import { UUID } from "../generic/uuid";
import { createWineDtoFromAdminWineModel, WineModel } from "./wine";
import { VintageRatingModel } from "./vintageRating";
import { VintageScoreModel } from "./vintageScore";
import { createImageDtoFromAdminImageModel, ImageModel } from "./image";
import { VintageDto } from "@vini-wine/core-dtos";

export interface VintageModel extends UUID {
  // transform
  year: number;

  // default includes
  bottleImage: ImageModel | null;

  // available includes
  wine?: WineModel;
  mappedExternal1Rating?: VintageRatingModel | null;
  scores?: VintageScoreModel[];
  labelImage?: ImageModel | null;
}

export const createVintageDtoFromAdminVintageModel = (
  vintage: VintageModel,
): VintageDto => {
  return {
    uuid: vintage.uuid,
    year: vintage.year,
    wine: vintage.wine
      ? createWineDtoFromAdminWineModel(vintage.wine)
      : undefined,
    bottleImage: vintage.bottleImage
      ? createImageDtoFromAdminImageModel(vintage.bottleImage)
      : null,
  };
};
